import React from 'react';
import { USER_ROLES } from '../../../utils/constants';
import { LeftMenuUser } from './LeftMenuUser';
import { CurrentUserLimits } from '../../../slices/current-user/current-user.state';
import { AdminMenu } from './roles/AdminMenu';
import { PracticeOwnerMenu } from './roles/PracticeOwnerMenu';
import { SecondaryUserMenu } from './roles/SecondaryUserMenu';
import { UserMenu } from './roles/UserMenu';
import { BuyerMenu } from './roles/BuyerMenu';
import { BrokerMenu } from './roles/BrokerMenu';
import { CharityAdminMenu } from './roles/CharityAdminMenu';
import { DefaultMenu } from './DefaultMenu';
import { isViewAsBuyerActive } from '../../../utils/viewAsBuyer';
import './ViewAsBuyerDisabledMenu.scss';

export interface RoleMenuSwitcherProps {
    user: LeftMenuUser;
    limits: CurrentUserLimits;
}

export const RoleMenuSwitcher = (props: RoleMenuSwitcherProps) => {
    const { user, limits } = props;

    if (isViewAsBuyerActive()) {
        return (
            <div className="view-as-buyer-disabled-menu">
                <BuyerMenu user={user} limits={limits} />
            </div>
        );
    }

    switch (user.roleId) {
        case USER_ROLES.ADMIN:
            return <AdminMenu />;
        case USER_ROLES.PRACTICE_OWNER:
            return <PracticeOwnerMenu user={user} limits={limits} />;
        case USER_ROLES.PRACTICE_SECONDARY_USER:
            return <SecondaryUserMenu user={user} limits={limits} />;
        case USER_ROLES.USER:
            if (user.isMarketplaceBuyer)
                return <BuyerMenu user={user} limits={limits} />;
            if (user.isMarketplaceBroker)
                return <BrokerMenu user={user} limits={limits} />;
            return <UserMenu user={user} limits={limits} />;
        case USER_ROLES.CHARITY_ADMIN:
            return <CharityAdminMenu user={user} limits={limits} />;
        default:
            return <DefaultMenu />;
    }
};
